import { useParams, useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import Form from "./Form";

export default function ConfirmEmail() {
  const { userId, token } = useParams();
  const navigate = useNavigate();

  const fields = [
    {
      id: "userId",
      type: "hidden",
      value: userId,
    },
    {
      id: "token",
      type: "hidden",
      value: token,
    },
  ];

  return (
    <AuthLayout heading="Confirm your email">
      <Form
        path="confirm-email"
        fields={fields}
        submitText="Confirm Email"
        updateCache={false}
        initialValues={{
          userId,
          token,
        }}
        submitCallback={(data) => {
          navigate("/confirm-email/done", { state: { message: data.message } });
        }}
      />
    </AuthLayout>
  );
}
